'use client';

import { Button, TextLink } from '@petsmart-ui/sparky';

import { useAuthSignInClick } from '@libs/common-next';

import TreatsRewardsIcon from '../shared/treats-rewards.icon.svg';

import './unauthenticated.scss';

const TREATS_REWARDS_HREF = '/treats-rewards';

type UnauthenticatedProps = {
    onAction: () => void;
};

export function Unauthenticated({ onAction }: UnauthenticatedProps) {
    const { isAuth0Enabled, handleSignInClick } = useAuthSignInClick();

    const handleGuestSignInClick = () => {
        onAction();
        handleSignInClick();
    };

    return (
        <div className="account-unauthenticated">
            <a
                href={TREATS_REWARDS_HREF}
                aria-label="Treats Rewards"
                className="account-unauthenticated__icon-link"
                onClick={onAction}
            >
                <TreatsRewardsIcon aria-hidden="true" className="account-unauthenticated__icon" />
            </a>

            <TextLink
                variant="secondary"
                href={TREATS_REWARDS_HREF}
                className="account-unauthenticated__link"
                onClick={onAction}
            >
                Join our <span className="account-unauthenticated__text-accent">loyalty program</span> & earn points
                every time you shop!
            </TextLink>

            <Button
                variant="primary"
                aria-label={isAuth0Enabled ? 'Sign in or create account' : 'Sign in'}
                text={isAuth0Enabled ? 'Sign in or create account' : 'Sign in'}
                className={
                    isAuth0Enabled
                        ? 'account-unauthenticated__sign-in-button account-unauthenticated__sign-in-button--auth0'
                        : 'account-unauthenticated__sign-in-button'
                }
                onClick={handleGuestSignInClick}
                type="button"
            />

            {!isAuth0Enabled && (
                <Button
                    aria-label="Create account"
                    text="Create account"
                    className="account-unauthenticated__create-account-button"
                    onClick={onAction}
                    href="/create-account"
                />
            )}
        </div>
    );
}
